<template>
  <!--  style fixes bulma overload-->
  <div
    class="dropdown-menu absolute z-dropdown select-none"
    style="display: block"
    :class="menuClasses"
    :style="verticalStyle"
  >
    <div class="z-dropdown overflow-hidden bg-white border border-50 shadow rounded-lg">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export const MENU_TOP = 'top';
  export const MENU_BOTTOM = 'bottom';
  export const MENU_MIDDLE = 'middle';
  export const MENU_ASIDE = 'aside';

  export default {
    props: {
      direction: {
        type: String,
        default: 'ltr',
        validator: value => ['ltr', 'rtl'].indexOf(value) !== -1,
      },
      verticalDirection: {
        type: String,
        default: 'bottom',
        validator: value => [MENU_TOP, MENU_BOTTOM, MENU_MIDDLE, MENU_ASIDE].indexOf(value) !== -1,
      },
      verticalStyle: {
        type: Object,
      },
    },
    computed: {
      menuClasses() {
        return [
          this.direction === 'ltr' ? 'dropdown-menu-left' : 'dropdown-menu-right',
          ...(this.verticalDirection === MENU_TOP ? ['dropdown-menu-top'] : []),
          ...(this.verticalDirection === MENU_MIDDLE ? ['dropdown-menu-middle'] : []),
          ...(this.verticalDirection === MENU_ASIDE ? ['dropdown-menu-aside'] : []),
        ];
      },
    },
  };
</script>
